import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg';
}
export function Card({
  children,
  className = '',
  padding = 'md'
}: CardProps) {
  const paddings = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };
  return <div className={`bg-white rounded-xl shadow-lg ${paddings[padding]} ${className}`} data-id="element-280">
      {children}
    </div>;
}